//
// NOTE all state is derived from a *single* meeting at a time
//
const state = {
	agendaMeetingId: "",
	meeting: {},
	meetingPermissions: {},
	assignedTeam: {
		id: "",
		type: "",
	},
	organizer: {
		personId: "",
	},
	invitees: [],
	// topicId => topicField
	topicFieldMap: {},
	// outcomeId => outcomeField
	outcomeFieldMap: {},

	// outcomeId => outcome (only used in store, maybe not needed?)
	meetingOutcomeMap: {},
	topicOutcomeIdMap: {},

	meetingInviteeMap: {},
	userProfile: {},
	timezone: "",
	/**
	 * @typedef {Object.<topicId, OutcomeField>}
	 */
	newOutcomeFieldMap: {},
	editingOutcomeId: "",

	//
	// flags
	//
	isInitializingMeetingAgendaStore: false,
	hasInitializedMeetingAgendaStore: false,
	isSavingTopicOutcome: false,
	isSavingExistingTopicOutcome: false,
	isSavingNewTopicOutcome: false,
	isDeletingExistingTopicOutcome: false,
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/meetingAgenda/state.js